<template>
    <div class="tenantMain tenantInfo position-relative">
        <div class="tenantCard lmu tenantForm tenantLogin">
            <div class="logo text-center mb-30">
                <img src="/img/tenants-logo-small.png" alt="">
            </div>
            <div class="tenantGuest">
                <b-row class="mb-35">
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Town Council"
                            vLabel="contract_name"
                            :filterable="false"
                            :append-to-body="true"
                            :required="true"
                            :show-icon-required="true"
                            :options="form.options.contracts"
                            @search="searchContract"
                            v-model="form.data.town_council">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Search"
                            v-model="form.data.equipment"
                            vLabel="tag_name"
                            :options="form.options.equipments"
                            @search="searchEquipment"
                            :filterable="false">
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <div class="flex">
                                    <div class="">
                                        <span>{{option.tagLocationPostalCode}}</span>
                                    </div>
                                </div>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <span>{{option.tagLocationPostalCode}}</span>
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="4">
                        <gofix-text-field class-label="width-115 mb-20" label="Lift Code" oneline>{{ form.data.lift_code }}</gofix-text-field>
                    </b-col>
                    <b-col md="4">
                        <gofix-text-field class-label="width-115 mb-20" label="Postal Code" oneline>{{ form.data.postal_code }}</gofix-text-field>
                    </b-col>
                    <b-col md="4">
                        <gofix-text-field class-label="width-115 mb-20" label="Block No" oneline>{{ form.data.block_number }}</gofix-text-field>
                    </b-col>
                    <b-col md="4">
                        <gofix-text-field class-label="width-115 mb-20" label="Lift No" oneline>{{ form.data.lift_number }}</gofix-text-field>
                    </b-col>
                    <b-col md="8">
                        <gofix-text-field class-label="width-115 mb-20" label="Location" oneline>{{ form.data.location && form.data.location.name ? form.data.location.name : null }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input label="Fault Event Number" v-model="form.data.fault_event_number" maxlength="25" required show-icon-required></gofix-form-input>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input-textarea :rows="5" label="Description Of Replacement Work For Approval" v-model="form.data.description"></gofix-form-input-textarea>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input label="Part Location" v-model="form.data.part_location"></gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="Requestor Name" v-model="form.data.requestor_name" disabled></gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-number
                            label="Requestor Contact No"
                            v-model="form.data.requestor_contact_no"
                            :integer-limit="15"
                            :include-thousands-separator="false"
                            :allowDecimal="false"
                            disabled>
                        </gofix-form-input-number>
                    </b-col>
                    
                    <b-col md="12" class="mb-4">
                        <div class="d-flex flex-wrap">
                            <template v-for="(attachment,index) in form.attachments">
                                <gofix-button class="icon-svg icon-svg-right mr-2 mb-2" :label="attachment.name" outline dark :key="index">
                                    <template slot="gofix:button:afterLabel">
                                        <span class="icon" @click="removeImage(index)">
                                            <svg width="12" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.3 0.99404C13.1131 0.797476 12.8595 0.687011 12.595 0.687011C12.3305 0.687011 12.0768 0.797476 11.89 0.99404L6.99997 6.11669L2.10997 0.983543C1.92314 0.786979 1.66949 0.676514 1.40497 0.676514C1.14045 0.676514 0.886802 0.786979 0.699971 0.983543C0.309971 1.39293 0.309971 2.05426 0.699971 2.46365L5.58997 7.5968L0.699971 12.73C0.309971 13.1393 0.309971 13.8007 0.699971 14.2101C1.08997 14.6195 1.71997 14.6195 2.10997 14.2101L6.99997 9.07691L11.89 14.2101C12.28 14.6195 12.91 14.6195 13.3 14.2101C13.69 13.8007 13.69 13.1393 13.3 12.73L8.40997 7.5968L13.3 2.46365C13.68 2.06476 13.68 1.39294 13.3 0.99404Z" fill="black" fill-opacity="0.6" />
                                            </svg>
                                        </span>
                                    </template>
                                </gofix-button>
                            </template>
                            <gofix-button class="icon-svg icon-svg-left mb-2" label="Add file" outline @click="modal.attachment.open = true">
                                <template slot="gofix:button:beforeLabel">
                                    <span class="icon">
                                        <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.6537 8.20604C11.6355 8.1827 11.6121 8.16382 11.5855 8.15083C11.5588 8.13785 11.5296 8.1311 11.4999 8.1311C11.4703 8.1311 11.441 8.13785 11.4144 8.15083C11.3877 8.16382 11.3644 8.1827 11.3461 8.20604L8.61175 11.6655C8.58921 11.6943 8.57522 11.7288 8.57139 11.7652C8.56755 11.8016 8.57403 11.8383 8.59007 11.8711C8.60612 11.904 8.63108 11.9317 8.66212 11.951C8.69315 11.9703 8.72899 11.9805 8.76556 11.9805H10.5698V17.8984C10.5698 18.0058 10.6576 18.0937 10.7651 18.0937H12.2299C12.3373 18.0937 12.4252 18.0058 12.4252 17.8984V11.9829H14.2343C14.3979 11.9829 14.4882 11.7949 14.3881 11.668L11.6537 8.20604Z" fill="#F05600" />
                                            <path d="M18.8096 5.95264C17.6914 3.00342 14.8423 0.90625 11.5049 0.90625C8.16748 0.90625 5.31836 3.00098 4.2002 5.9502C2.10791 6.49951 0.5625 8.40625 0.5625 10.6719C0.5625 13.3696 2.74756 15.5547 5.44287 15.5547H6.42188C6.5293 15.5547 6.61719 15.4668 6.61719 15.3594V13.8945C6.61719 13.7871 6.5293 13.6992 6.42188 13.6992H5.44287C4.62012 13.6992 3.84619 13.3721 3.27002 12.7788C2.69629 12.188 2.39111 11.3921 2.41797 10.5669C2.43994 9.92236 2.65967 9.31689 3.05762 8.80664C3.46533 8.28662 4.03662 7.9082 4.67139 7.73975L5.59668 7.49805L5.93604 6.60449C6.146 6.04785 6.43896 5.52783 6.80762 5.05664C7.17156 4.58962 7.60267 4.17908 8.08691 3.83838C9.09033 3.13281 10.272 2.75928 11.5049 2.75928C12.7378 2.75928 13.9194 3.13281 14.9229 3.83838C15.4087 4.18018 15.8384 4.59033 16.2021 5.05664C16.5708 5.52783 16.8638 6.05029 17.0737 6.60449L17.4106 7.49561L18.3335 7.73975C19.6567 8.09619 20.582 9.2998 20.582 10.6719C20.582 11.48 20.2671 12.2417 19.6958 12.813C19.4156 13.0948 19.0823 13.3182 18.7152 13.4703C18.3481 13.6225 17.9545 13.7003 17.5571 13.6992H16.5781C16.4707 13.6992 16.3828 13.7871 16.3828 13.8945V15.3594C16.3828 15.4668 16.4707 15.5547 16.5781 15.5547H17.5571C20.2524 15.5547 22.4375 13.3696 22.4375 10.6719C22.4375 8.40869 20.897 6.5044 18.8096 5.95264Z" fill="#F05600" />
                                        </svg>
                                    </span>
                                </template>
                            </gofix-button>
                        </div>
                    </b-col>
                    <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" modal-class="gofixUploadFileModal" hide-footer v-model="modal.attachment.open">
                        <b-form class="formV2">
                            <b-form-group :label="modal.attachment.filename" >
                                <b-form-file ref="file-input" v-model="modal.attachment.fileAttachment" ></b-form-file>
                            </b-form-group>
                            <b-button-group class="text-right d-block">
                                <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modal.attachment.loading"></gofix-button>
                            </b-button-group>
                        </b-form>
                    </b-modal>
                </b-row>
                <hr class="w-100 mt-5 mb-20" />
                <template v-if="form.data.line_items.length">
                    <template v-for="(item, index) in form.data.line_items">
                        <b-row align-v="center" :key="index">
                            <b-col md="12">
                                <div class="d-flex align-items-center justify-content-between action actionFloat actionFloat__extra d-flex font-weight-bold">
                                    <h4>
                                        <b-badge variant="secondary">#{{index+1}}</b-badge>
                                        <!-- <gofix-button class="mb-0 gofixButtonFix" label="Add new item +" outline></gofix-button> -->
                                    </h4>
                                    <div class="pb-1">
                                        <b-button @click="addItem(index)" title="Create" v-b-tooltip.hover>
                                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                                <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                                <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                            </svg>
                                        </b-button>
                                        <b-button @click="delItem(index)" title="Delete" v-b-tooltip.hover>
                                            <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                                <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                            </svg>
                                        </b-button>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12">
                                <gofix-form-dropdown
                                    class="fakeTable"
                                    label="Sor Code"
                                    vLabel="sor_code"
                                    :filterable="false"
                                    @search="(search, loading) => {
                                        searchSOR(search, loading, index)
                                    }"
                                    v-model="item.sor"
                                    :options="form.sorOptions[`item_${index+1}`] || []">
                                    <template #gofixInput:dropdown:list-header>
                                        <div class="d-table fakeTableHeader">
                                            <div class="d-table-cell cell itemTitle itemCode">Code</div>
                                            <div class="d-table-cell cell itemTitle itemDescription">Description</div>
                                        </div>
                                    </template>
                                    <template #gofixInput:dropdown:option="{ sor_code , description_one, description_two, unit_price }">
                                        <div class="d-table fakeTableBody">
                                            <div class="d-table-cell cell itemValue itemCode">{{sor_code}}</div>
                                            <div class="d-table-cell cell itemValue itemDescription">
                                                {{description_one}} <span class="color-red" v-if="description_two"> - {{description_two}}</span>
                                            </div>
                                            <div class="d-table-cell cell itemValue itemUnitPrice text-right">{{ unit_price | formatMoney}}</div>
                                        </div>
                                    </template>
                                </gofix-form-dropdown>
                            </b-col>
                            <b-col md="12" class="mb-3">
                                <gofix-text-field label="Description" oneline >
                                    <div v-html="$options.filters.showDescription(item.sor)"></div>
                                </gofix-text-field>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <gofix-text-field class-label="min-width-105" label="Unit Price" oneline>{{ item.sor && item.sor.unit_price ? item.sor.unit_price : 0 | formatMoney }}</gofix-text-field>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <gofix-form-input-number 
                                    label="Quantity" 
                                    v-model="item.quantity">
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <gofix-text-field label="Total Price" oneline>{{ item.sor && item.sor.unit_price && item.quantity ? item.quantity * item.sor.unit_price : 0 | formatMoney }}</gofix-text-field>
                            </b-col>
                            <hr v-if="index != (form.data.line_items.length - 1)" class="w-100 mt-5 mb-20" />
                        </b-row>
                    </template>
                </template>
                <gofix-button v-else class="mb-3 pt-6 pb-6" label="Add Item +" @click="addItem(null)" outline></gofix-button>
            </div>
            <div class="text-center mt-3">
                <!-- <gofix-button class="mw-250 mb-3 mx-2" label="Back to Portal" large @click="backPortal" outline></gofix-button> -->
                <gofix-button class="mw-250 mb-3 mx-2" label="SUBMIT" large :disabled="!form.data.town_council || !form.data.equipment || !form.data.fault_event_number || form.loading" @click="save"></gofix-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'lmu-approval-form',
        props: {
            
        },
        data() {
            return {
                form: {
                    loading: false,
                    options: {
                        contracts: [],
                        equipments: [],
                    },
                    attachments: [],
                    data: {
                        town_council: null,
                        equipment: null,
                        lift_code: null,
                        lift_number: null,
                        postal_code: null,
                        location: null,
                        block_number: null,
                        description: null,
                        part_location: null,
                        requestor_name: null,
                        requestor_contact_no: null,
                        fault_event_number: null,
                        file: null,
                        line_items: []
                    },
                    check: '',
                    sorOptions: {},
                    loadingModal: false
                },
                timer: {
                    contracts: null,
                    equipments: null,
                    sor: null,
                    save: null
                },
                modal:{
                    open: false,
                    title: null,
                    loading: false,
                    data: {
                        data_from_iems: null,
                        feedback_from_rc: null,
                        feedback_from_sm: null
                    },
                    index: null,
                    attachments: [],
                    attachmentUpdate: [],
                    attachmentDeleteId: [],
                    attachment_tmp: {
                        delete: [],
                        add: [],
                        update: []
                    },
                    attachment:{
                        open: false,
                        loading: false,
                        filename: "Click Browse to upload file",
                        fileAttachment: null,
                        image_file_title: '',
                        id: 0,
                        index: '',
                        edit: 0
                    },
                    download:{
                        open: false,
                        loading: false,
                        title:'',
                        attachments: []
                    }
                },
            }
        },
        watch: {
            "form.data.town_council": function(val) {
                if(val) {
                    this.getEquipments()
                    this.getListSOR()
                } else {
                    this.form.data.equipment = null
                    this.form.options.equipments = [];
                    for(let i = 0; i < this.form.data.line_items.length; i++) {
                        this.form.sorOptions[`item_${i+1}`] = []
                        this.form.data.line_items[i].sor = null
                    }
                }
            },
            "form.data.equipment": function(val) {
                if(val) {
                    this.form.data.lift_code = val.tag_name
                    this.form.data.location = val.location_info
                    if(val.custom_fields) {
                        let custom_fields = val.custom_fields;
                        custom_fields.map(item => {
                            let key = item.attribute.name ? item.attribute.name.toLowerCase().replaceAll(' ', '_') : '';
                            if(key == 'block_no' || key == 'block_number') key = 'block_number';
                            if(key == 'lift_no' || key == 'lift_letter') key = 'lift_number';
                            if(this.form.data.hasOwnProperty(key)) {
                                let value = item.value;
                                if(value && item.attribute.type === "DateTime") {
                                    value = moment(value).format("DD.MM.YYYY");
                                }
                                if(value){
                                    this.form.data[key] = value;
                                }
                            }
                        })
                    }
                } else {
                    this.form.data.lift_code = null
                    this.form.data.location  = null
                    this.form.data.postal_code  = null
                    this.form.data.block_number = null
                    this.form.data.lift_number  = null
                }
            },
            "modal.attachment.fileAttachment": function(val) {
                this.modal.attachment.filename = 'Click Browse to upload file';
                if (val) {
                    let extensionAccept = ['csv', 'xls', 'xlsx', 'docx', 'doc', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif','msg','html','htm','zip'];
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if (!extensionAccept.includes(extension)) {
                        this.$refs['file-input'].reset()
                        return this.$bvToast.toast('File format is incorrect. Please select a .csv, .xls, .xlsx, .docx, .doc, .pdf, .txt, .jpeg, .jpg, .png, .gif file!', {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'warning',
                            solid: true
                        })
                    }
                    this.modal.attachment.filename = val.name
                }
            },
            user: function(val) {
                if(val) this.getUser()
            }
        },
        filters:{
           showDescription(val) {
                let description = '';
                if(val) {
                    description = val.description_one;
                    if(val.description_two) {
                        description += ` - <span class="color-red">${val.description_two}</span>`;
                    }
                }
                return description;
            },
        },
        created() {
            this.getContracts()
            if(this.user && this.user.id) this.getUser()
            this.form.sorOptions = Object.assign({}, {})
            for(let i = 0; i < 5; i++) {
                this.form.data.line_items.push({
                    sor: null,
                    quantity: 1,
                })
                this.form.sorOptions[`item_${i+1}`] = []
            }
        },
        computed: {
            ...mapGetters({
                user : 'AuthController/user',
            }),
        },
        methods: {
            /*-- Header --------*/
            getUser() {
                this.$store.dispatch('v2UserController/getUser', this.user.id)
                .then(response => { 
                    if(response.data.data) {
                        this.form.data.requestor_name = response.data.data.name
                        if(response.data.data.address && response.data.data.address.length) {
                            this.form.data.requestor_contact_no = response.data.data.address[0].primary_phone
                        }
                    }
                })
                .catch(error => {})
            },
            async getContracts(filter = null) {
                await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, filter, 1000])
                .then(response => {  
                    this.form.options.contracts = response.data; 
                }).catch(error => {
                    console.log(error);
                })
            },
            searchContract(search, loading){
                this.form.options.contracts = []
                loading(true);
                if(this.timer.contracts) {
                    clearTimeout(this.timer.contracts);
                    this.timer.contracts = null;
                }
                this.timer.contracts = setTimeout(async () => {
                    try {
                        await this.getContracts({ contract_name: search });
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
            async getEquipments(tag_name = null) {

                let town_council_id = 0;
                if(this.form.data.town_council){
                    town_council_id = this.form.data.town_council.id
                }

                this.form.options.equipments = []
                let tableRequest = {
                    filter: {
                        contract_id: town_council_id,
                        tag_name: tag_name,
                        is_active: true,
                        location_in_lift: true
                    },
                    limit: 50,
                    isCMS: false,
                    sortColumn: 'tag_name',
                    sortDirection: 'ASC',
                }
                await this.$store.dispatch("PartReplacementController/getEquipment", tableRequest)
                .then(response => {
                    this.form.options.equipments = response.items;
                }).catch(err => {})
            },
            async searchEquipment(search, loading) {
                loading(true)
                if (this.timer.equipments) {
                    clearTimeout(this.timer.equipments);
                    this.timer.equipments = null;
                }
                this.timer.equipments = setTimeout(async () => {
                    try {
                        await this.getEquipments(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },

            /*-- Attachment --------*/
            addAttachment() {
                if(!this.modal.attachment.fileAttachment) {
                    return this.$bvToast.toast('Please select the file.', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                this.form.attachments.push(this.modal.attachment.fileAttachment);
                this.modal.attachment.fileAttachment = null;
                this.modal.attachment.open = false;
            },
            removeImage(index) {
                this.form.attachments.splice(index, 1);
            },
            
            /*-- Line items --------*/
            addItem(index) {
                if(index === null) {
                    this.form.data.line_items.push({
                        sor: null,
                        quantity: 1,
                    });
                    this.form.sorOptions[`item_${this.form.data.line_items.length-1}`] = []
                } else {
                    this.form.data.line_items.splice(index, 0, Object.assign({}, {
                        sor: null,
                        quantity: 1,
                    }));
                    this.form.sorOptions[`item_${index+1}`] = []
                }
                
                this.getListSOR()
                this.$root.$emit('bv::hide::tooltip');
            },
            delItem(index) {
                this.$delete(this.form.data.line_items, index);
                this.$delete(this.form.sorOptions, index);
                this.$root.$emit('bv::hide::tooltip');
            },
            async getListSOR(sftSor = null, index = null){
                if(!this.form.data.town_council || !this.form.data.town_council.contract_terms) return
                await this.$store.dispatch( 'v2SorController/searchSorCode',
                [1, 100, '',
                        {
                        contract_term_id: this.form.data.town_council.contract_terms[0] ? this.form.data.town_council.contract_terms[0].id : null,
                        is_maintenance: false,
                        search: sftSor,
                    },
                    this.form.data.town_council ? this.form.data.town_council.id : null
                ])
                .then(response => {
                    let items = response.data.data.items
                    if(index === null) {
                        let arrTmp = {}
                        for(let i = 0; i < this.form.data.line_items.length; i++) {
                            arrTmp[`item_${i+1}`] = items
                        }
                        this.form.sorOptions = Object.assign({}, arrTmp)
                        
                    } else {
                        this.$set(this.form.sorOptions, [`item_${index+1}`], items);
                    }
                    this.form.loadingModal = false
                })
                .catch(err => {
                    this.form.loadingModal = false
                })
            },
            async searchSOR(search, loading, index){
                if(index !== null && this.form.sorOptions[`item_${index+1}`]) this.form.sorOptions[`item_${index+1}`] = []
                loading(true);
                if(this.timer.sor) {
                    clearTimeout(this.timer.sor);
                    this.timer.sor = null;
                }
                this.timer.sor = setTimeout(async () => {
                    try {
                        await this.getListSOR(search, index);
                        await loading(false)
                    } catch(e) {
                        console.log(e)
                        loading(false)
                    }
                },300)
            },

            /*-- Action --------*/
            resetForm() {
                this.form.attachments = []
                this.form.data = Object.assign(this.form.data, {
                    town_council: null,
                    equipment: null,
                    lift_code: null,
                    lift_number: null,
                    postal_code: null,
                    location: null,
                    block_number: null,
                    description: null,
                    part_location: null,
                    fault_event_number: null,
                    file: null,
                    line_items: []
                })
                this.form.sorOptions = Object.assign({}, {})
                for(let i = 0; i < 5; i++) {
                    this.form.data.line_items.push({
                        sor: null,
                        quantity: 1,
                    })
                    this.form.sorOptions[`item_${i+1}`] = []
                }
            },
            backPortal() {
                this.$router.push(`/supplier-portal/dashboard`)
            },
            save() {
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(async () => {
                    if(this.form.data.fault_event_number.length > 25) {
                        return this.$alertNotification('Maximum length is 25 characters', 'danger');
                    }

                    var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
                    if(format.test(this.form.data.fault_event_number)) {
                        return this.$alertNotification('Fault event number must not contain special characters', 'danger');
                    }

                    this.form.loading = true;
                    let line_items = []
                    this.form.data.line_items.forEach(item => {
                        if(item.sor && item.quantity) {
                            let sor_description = item.sor.description_one ;
                            if(item.sor.description_two)
                                sor_description += ` - <span class="color-red">${item.sor.description_two}</span>`
                            let index = line_items.findIndex(x => x.sor_item_id == item.sor.id);
                            if(index !== -1) {
                                line_items[index].quantity = line_items[index].quantity + Number(item.quantity)
                            } else {
                                line_items.push({
                                    sor_item_id: item.sor.id,
                                    sor_code: item.sor.sor_code,
                                    sor_description: sor_description,
                                    unit_price: item.sor.unit_price,
                                    quantity: Number(item.quantity),
                                })
                            }
                        }
                    });
                    let objeClone = {
                        client_contract_id: this.form.data.town_council.id,
                        lift_code: this.form.data.lift_code,
                        equipment_id: this.form.data.equipment.id,
                        description: this.form.data.description,
                        photos: this.form.attachments,
                        part_location: this.form.data.part_location,
                        fault_event_number: this.form.data.fault_event_number,
                        line_items: line_items
                    }

                    this.$store.dispatch(`LMUApprovalRequestController/submitApprovalRequest`, objeClone)
                    .then(async response => {
                        this.form.loading = false;
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.$alertNotification('Successfully submitted approval request');
                        this.resetForm()
                    })
                    .catch(err => {
                        this.form.loading = false;
                        if(err.response && err.response.data.error && err.response.data.error.message  && err.response.data.error.message.error) {
                            this.$alertNotification(err.response.data.error.message.error, "danger"); 
                        }
                    })

                }, 200);
            }
        }
    }
</script>
